function handleCustomLinkRedirect(url) {
    var redirectDelay = 5000; //5s
    if (!url) {
      return;
    }
    scheduleRedirect(url, redirectDelay);
  
    function scheduleRedirect(url, delay) {
      setTimeout(function redirectToCompletionUrl() {
        window.location.href = url;
      }, delay);
    }
}
  